import React, { useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Table from '../../Components/Table';
import { addTimesheet, getTimesheets, updateTimesheet } from '../../Services/TimeSheet/action';
import { connect } from 'react-redux';
import { FaUserCircle } from 'react-icons/fa';
import UserAvatar from 'react-user-avatar';
import Skeleton from 'react-loading-skeleton';

const header = [
  { field: "Task" },
  { field: "Time" },
  { field: "Total Hours" },
  { field: "Earnings" },
  { field: "Action" },
];

function TimeSheetEmployee(props) {
  useEffect(() => {
    props?.getTimesheets();
  }, []);

  const calculateElapsedWithPauses = (startTimeStr, actionHistory = []) => {
    let totalSeconds = 0;
    let currentStart = new Date(startTimeStr);
    let isRunning = true;

    const sortedHistory = [...actionHistory].sort(
      (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
    );

    for (const action of sortedHistory) {
      const actionTime = new Date(action.timestamp);

      if (action.action === "pause" && isRunning) {
        totalSeconds += Math.floor((actionTime - currentStart) / 1000);
        isRunning = false;
      } else if (action.action === "resume" && !isRunning) {
        currentStart = actionTime;
        isRunning = true;
      } else if (action.action === "stop" && isRunning) {
        totalSeconds += Math.floor((actionTime - currentStart) / 1000);
        isRunning = false;
      }
    }

    if (isRunning) {
      totalSeconds += Math.floor((new Date() - currentStart) / 1000);
    }

    return totalSeconds;
  };

  const user = props?.user;

  const userTimesheets = props?.timesheet?.filter(item => {
    return item?.task?.taskTimerMap?.some(timer =>
      timer?.employee_id === user?.id &&
      timer?.start_time?.split(' ')[0] === item?.start_date?.split(' ')[0] &&
      timer?.start_time?.split(' ')[1] === item?.start_time
    );
  }) || [];

  let grandTotalElapsedTime = 0;

  const formattedRows = userTimesheets.map(item => {
    const allTimers = item?.task?.taskTimerMap || [];
    const taskDate = item?.start_date?.split(' ')[0];

    let totalElapsedTime = 0;

    allTimers.forEach(timer => {
      const timerDate = timer?.start_time?.split(' ')[0];

      if (
        timer?.employee_id === user?.id &&
        timerDate === taskDate &&
        timer?.start_time?.split(' ')[1] === item?.start_time &&
        timer?.start_time
      ) {
        if (timer?.duration &&
          item?.end_time) {

          const [hh, mm, ss] = timer.duration
            .split(/[hms\s]+/)
            .filter(Boolean)
            .map(Number);
          totalElapsedTime += hh * 3600 + mm * 60 + ss;
        } else {
          const actionHistory = typeof timer.action_history === "string"
            ? JSON.parse(timer.action_history)
            : timer.action_history || [];

          const seconds = calculateElapsedWithPauses(timer.start_time, actionHistory);
          totalElapsedTime += seconds;
        }
      }
    });

    grandTotalElapsedTime += totalElapsedTime;

    const totalH = Math.floor(totalElapsedTime / 3600);
    const totalM = Math.floor((totalElapsedTime % 3600) / 60);
    const totalS = totalElapsedTime % 60;

    return {
      Task: {
        value: item.task?.title,
        type: 'text'
      },
      Time: {
        value: item?.start_time,
        value2: item?.end_time,
        type: 'clockinout'
      },
      "Total Hours": {
        value: `${totalH}h ${totalM}m ${totalS}s`,
        type: "text"
      },
      Earnings: {
        value: "₹0.00",
        type: 'text'
      },
      Action: {
        value2: '/timelogs/view',
        value: '/timelogs/edit',
        type: 'action'
      },
      allData: { ...item }
    };
  });

  const totalgrandH = Math.floor(grandTotalElapsedTime / 3600);
  const totalgrandM = Math.floor((grandTotalElapsedTime % 3600) / 60);
  const totalgrandS = grandTotalElapsedTime % 60;
  const totalGroupedHours = `${totalgrandH}h ${totalgrandM}m ${totalgrandS}s`;

  return (
    <Accordion>
      {
        props.loading ? (
          <Skeleton className='rounded-2' width="100%" height={50} />
        ) : (
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            className="timesheetemployee"
          >
            <div className="timesheet-employee-info">
              {user?.profile_pic?.data ? (
                <img
                  src={`data:image/jpeg;base64,${btoa(
                    new Uint8Array(user?.profile_pic?.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                  )}`}
                  alt="Profile"
                />
              ) : (
                <UserAvatar name={user?.name} size={40} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                // <FaUserCircle size={40} color="rgb(180, 180, 180)" />
              )}
              <div className="employee-info-details">
                <span>{user?.name}</span>
                <span className="role">{user?.designation?.name}</span>
              </div>
            </div>

            <div className='timesheet-employee-detail'>
              <div>
                <label className='Timesheet-label'><span>{totalGroupedHours}</span> Hours Logged</label>
              </div>
              <div>
                <label className='Timesheet-label'><span>₹0.00</span> Earnings</label>
              </div>
            </div>
          </AccordionSummary>
        )
      }

      <AccordionDetails>
        <div className='timesheet-emp-table' style={{ border: '1px solid lightgray' }}>
          <Table
            header={header}
            data={formattedRows}
            footer={true}
            count={formattedRows.length}
            records={formattedRows.length}
            showIsView={true}
            showIsEdit={true}
            TaskApprove={true}
          />
        </div>
      </AccordionDetails>
    </Accordion>
  );
}

const mapStateToProps = (state) => ({
  loading: state.timesheetReducer.loading,
  timesheet: state.timesheetReducer.timesheet,
  user: state.authenticationReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
  getTimesheets: () => dispatch(getTimesheets()),
  addTimesheet: (data) => dispatch(addTimesheet(data)),
  updateTimesheet: (id, data) => dispatch(updateTimesheet(id, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeSheetEmployee);
